import { useMemo } from 'react';
import { FieldErrors, useFormContext } from 'react-hook-form';
import { Title } from '../components/Title';
import { IndicatorType, WorkflowIndicator } from '../components/WorkflowIndicator';

interface FormSequenceViewProps extends React.PropsWithChildren {
  forceIndicatorType?: IndicatorType;
  title?: string;
  isFirst: boolean;
  isLast: boolean;
  fieldErrors: FieldErrors;
  fieldName: string;
  classname?: string;
}

export const FormSequenceView = ({ isFirst, isLast, fieldErrors, fieldName, children, forceIndicatorType, title, classname }: FormSequenceViewProps) => {
  const { watch } = useFormContext();

  const fieldValue = watch(fieldName);

  const indicatorType = useMemo(() => {
    if (forceIndicatorType) {
      return forceIndicatorType;
    }
    if (fieldErrors) {
      return IndicatorType.Error;
    }
    if (![undefined, null, ''].includes(fieldValue)) {
      return IndicatorType.Success;
    }
    return isLast ? IndicatorType.Active : IndicatorType.Default;
  }, [fieldErrors, fieldValue, forceIndicatorType, isLast]);

  return (
    <div className={`flex flex-row ${classname}`}>
      <WorkflowIndicator type={indicatorType ?? IndicatorType.Active} isFirst={isFirst} isLast={isLast} title={`Step ${fieldName}`} />
      <div className="w-full">
        {title && <Title text={title} className="mt-7 mb-5" />}
        {children}
      </div>
    </div>
  );
};
